function setDescription(){
  if (document.querySelector('.show-more-wrapper')){
    document.querySelectorAll('.show-more-wrapper').forEach(item=>{

      if (item.querySelector('.show-more-btn')){
        item.querySelector('.show-more-btn').addEventListener('click', function(){
          console.log(item.querySelector('.show-more-first'));
            item.querySelector('.show-more-first').classList.add('currently-hidden');
          item.querySelector('.show-more-last').classList.remove('currently-hidden');
          console.log('click')
        });
      }
      if (item.querySelector('.show-less-btn')){
        item.querySelector('.show-less-btn').addEventListener('click', function(){
          item.querySelector('.show-more-first').classList.remove('currently-hidden');
          item.querySelector('.show-more-last').classList.add('currently-hidden');
        });
      }


    });
    console.log('set 2');
  }
  console.log('set');

}
document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function(){
      setDescription();
    }, 500)
});
